import React,{Component} from 'react'
import NavItem from '../NavItem'
import { withRouter } from 'react-router-dom'

class AdminMenu extends Component{
    render(){
        return(
            <React.Fragment>
                <NavItem to={`/admin/companies/`} >
                    <i className="icon-pencil3"></i> <span>Компании</span>
                </NavItem>
                <NavItem  to={`/admin/reports`}>
                    <i className="icon-file-spreadsheet"></i> <span>Отчеты</span>
                </NavItem>
                <NavItem  to={`/dashboard/parser`}>
                    <i className="icon-grid2"></i> <span>Результаты парсинга</span>
                </NavItem>
            </React.Fragment>
        )
    }
}

export default withRouter(AdminMenu)


// WEBPACK FOOTER //
// ./src/components/Shared/SideBar/AdminMenu.jsx